module.exports = __webpack_public_path__ + "static/media/广州大学@2x.443defe9.png";